import {
  removeToken,
  removeRefreshToken,
  removeAccessExpiry
} from "./storageUtils";

/**
 * Purge complète de la session côté client puis redirection sur /login.
 *
 * <p>Doit nettoyer <strong>toutes</strong> les clés posées au login
 * ({@code Bearer}, {@code RefreshToken}, {@code AccessExpiry},
 * {@code userdata}) — sinon un refresh préventif peut tenter de réutiliser
 * un refresh token déjà révoqué côté back.
 *
 * <p>Pas d'appel back ici tant qu'aucun endpoint logout n'est exposé
 * (cf. P2#7 — décision architecturale en attente).
 */
export const logoutHelper = () => {
  localStorage.removeItem("userdata");
  removeToken();
  removeRefreshToken();
  removeAccessExpiry();

  return window.location.replace("/login");
};
